import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, forwardRef, DoCheck } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { isUndefined, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { RemunerationPeriodParent } from '../RemunerationsShared/remuneration-period-table-edit.component';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '../../../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { confirmRemoveFromList } from '../../../_infrastructure/TableEdit/TableEditBase';
import { WorkflowComponent } from '../../workflow.component';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';
import { CurrencyFormat } from '../../../_infrastructure/objectUtils';

@Component({
    selector: 'remunerations-last-three-years',
    templateUrl: './remunerations-last-three-years.component.html',
    providers: [{ provide: RemunerationPeriodParent, useExisting: forwardRef(() => RemunerationsLastThreeYearsComponent) },
        { provide: ICardComponentInjectionToken, useExisting: forwardRef(() => RemunerationsLastThreeYearsComponent) }],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})

export class RemunerationsLastThreeYearsComponent implements OnInit, OnDestroy, ICardComponent, RemunerationPeriodParent, DoCheck {
  public cardData: models.RemunerationsLastThreeYearsVM = {} as models.RemunerationsLastThreeYearsVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;
  public disableTableRemoveIcons: boolean = false;

  public expandedRowIndex: number = null;
  public expandNewEntry: boolean = false;

  public parentWorkflow: WorkflowComponent;
  public professionalClass: string;
  public subscriberType: string;
  public subscriber: models.SubscriberInformationVM;
  public isMedicalBonif: boolean;
  public isTeacher: boolean;
  public minEndDate: Date;
  public isCIT: boolean;
  public atLeastOneEntry: boolean;
  

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.scheduleRegimen)
  public scheduleTypes: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  
  constructor(private modalService: ModalService, private subscriberInfoService: SubscriberInformationService) {
    
  }

  ngOnInit(): void {
    //TEMP to prevent undefined errors if no stepdata is found
    if (isNullOrUndefined(this.cardData.remunerationsList))
      this.cardData.remunerationsList = [];
    if (this.isVersion2()) {
      if (!this.checkSteps()) {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo && this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo['CGAPensionStatus']?.professionalCategoryCode;
        this.subscriberType = this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo && this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo['CGAPensionStatus'].subscriberTypeCode;
      } else {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.professionalCategoryCode;
        this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode;
      }
    }
  }

  ngDoCheck(): void {
    if (isNullOrUndefined(this.cardData.remunerationsList))
      this.cardData.remunerationsList = [];
    if (this.isVersion2()) {
      this.minEndDate = new Date("2006-01-01T00:00:00");
      if (!this.checkSteps()) {
        if (isNullOrUndefined(this.professionalClass)) {
          this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.professionalCategoryCode;
        }
        if (isNullOrUndefined(this.subscriberType)) {
          this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
        }
        if (isNullOrUndefined(this.isCIT))
          this.isCIT = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.workAssignmentCode === '5';
      } else {
        if (isNullOrUndefined(this.professionalClass))
          this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.professionalCategoryCode;
        if (isNullOrUndefined(this.subscriberType))
          this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode;
        if (isNullOrUndefined(this.isCIT))
          this.isCIT = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.workAssignmentCode === '5';
      }

      this.isTeacher = this.checkIfTeacher();
      this.isMedicalBonif = this.checkIfMedicalBonif();

      if (this.isTeacher || this.isMedicalBonif || this.isCIT || this.checkIfToggleIsTrue()) {
        this.atLeastOneEntry = true;
      } else {
        this.atLeastOneEntry = false;
      }
    }
  }

  ngOnDestroy(): void {
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  checkSteps() {
    let result = false;
    for (let i = 0; i < this.parentWorkflow.steps.length; i++) {
      if (this.parentWorkflow.steps[i].stepCode === "StepSubscriberCGA") {
        result = true;
        break;
      }
    }
    return result;
  }

  checkIfTeacher() {
    let result = false;
    let profCats = ['9', '35', '10', '34'];
    if (profCats.indexOf(this.professionalClass) >= 0)
      result = true
    return result;
  }

  checkIfMedicalBonif() {
    let result = false;
    let isMedic = false;
    let profCats = ['12', '14'];

    if (profCats.indexOf(this.professionalClass) >= 0)
      isMedic = true

    if (isMedic) {
      let bonifs = ['111', '112', '113', '114'];
      let effMapEntries = this.parentWorkflow.workflowInstance.formData['StepMap']?.['EffectivityMap']?.['effectivityList'];

      if (effMapEntries?.length > 0) {
        for (let i = 0; i < effMapEntries.length; i++) {
          if (bonifs.indexOf(effMapEntries[i]?.['bonus']) >= 0) {
            result = true;
          }
        }
      }
    }
    return result;
  }

  checkIfToggleIsTrue(): boolean {
    let result = false
    if (this.cardData.differentOffices3?.toString() === 'true' || this.cardData.differentRegimes3?.toString() === 'true' || this.cardData.differentRenumerations3?.toString() === 'true') {
      result = true;
      this.atLeastOneEntry = true;
    } else {
      this.atLeastOneEntry = false;
    }
    return result;
  }

  onRemunerationsListChanged(newList: models.RemunerationPeriodEntryVM[]) {
    this.sortListByStartDate(newList);
    this.cardData.remunerationsList = newList;
    this.expandedRowIndex = null;
    this.expandNewEntry = false;
  }

  removeFromList(currentList: any[], indexToRemove: number, event: MouseEvent) {
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result)
          this.expandedRowIndex = null;
      });
    }
    event.stopPropagation();
  }
  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }

  sortListByStartDate(remunerationsList: models.RemunerationPeriodEntryVM[]) {
    remunerationsList.sort((first, second) => first.startDate?.getTime() - second.startDate?.getTime());
  }

  public currencyFormat(value) {
    return CurrencyFormat(value);
  }
}
